export default function CoursePath(course) {
  if (Object.is(course, null)) {
    return "";
  }
  //const mentoriaPath = (course.category === "mentoria") ? "-mentoria" : "";
  //const coursePath = "/courses/" + course.name + mentoriaPath;
  //return coursePath;
  return "/courses/" + course.name;
}
